import { gql } from 'apollo-boost';
import { useQuery } from '@apollo/react-hooks';

export const GET_LANGUAGE = gql`
    query Language {
        language @client {
            language
        }
    }
`;

export default () => useQuery(GET_LANGUAGE);